import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { useConnectionsApi } from '@/api/connections.ts';

const ConnectionCrumb = () => {
    const { connectionId } = useParams();
    const connections = useConnectionsApi().useListConnections();
    const connection = connections.data?.find((item) => item.id === connectionId);

    return connection ? <>{connection.name}</> : null;
};

// A user's own connections, below their settings (plan task 35).
export const OwnConnectionsCrumb = () => {
    const { t } = useTranslation();
    return <>{t('connections.ownTitle')}</>;
};

export default ConnectionCrumb;
